import {NavBarItem} from "./navBar";
import {RoutePath} from "../../router/routePath";

const data: NavBarItem[] = [
    {
        name: "Dashboard",
        route: RoutePath.dashboard,
    },
    {
        name: "Campaigns",
        route: RoutePath.campaign,
    },
    {
        name: "Patients",
        route: RoutePath.patients,
    },
    // {
    //     name: "Conversations",
    //     route: RoutePath.conversations,
    // },
    // {
    //     name: "Surveys",
    //     route: RoutePath.surveys,
    // },
    // {
    //     name: "Engagement Analytics",
    //     route: RoutePath.engagementAnalytics,
    // },
    // {
    //     name: "Cost Analytics",
    //     route: RoutePath.costAnalytics,
    // },
]

export default data
